import React from 'react';
import { FadeIn } from './FadeIn';
export function MyStory() {
  return <section className="relative py-16 md:py-24 bg-white overflow-hidden" data-id="element-623">
      {/* Organic blob background */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none" data-id="element-624">
        <div className="absolute top-1/4 left-[-10%] w-[40%] h-[60%] bg-forest/5 rounded-full blur-3xl" data-id="element-625"></div>
        <div className="absolute bottom-[-10%] right-[-5%] w-[50%] h-[50%] bg-gold/5 rounded-full blur-3xl" data-id="element-626"></div>
      </div>
      <div className="max-w-[900px] mx-auto px-6 md:px-8 relative z-10" data-id="element-627">
        <FadeIn data-id="element-628">
          <div className="bg-ivory/60 border border-gold/20 rounded-[24px] p-8 md:p-12 lg:p-14 shadow-sm" data-id="element-629">
            <h2 className="text-3xl md:text-4xl font-serif font-medium text-forest mb-8 text-center" data-id="element-630">
              De ce lucrez cu femei care se simt epuizate
            </h2>

            <div className="space-y-5 text-charcoal/80 font-sans text-[19px] leading-relaxed" data-id="element-631">
              <p data-id="element-632">
                Știu cum e să construiești o viață care arată bine din exterior,
                dar să simți în interior că nu te mai reprezintă. Știu cum e să
                muncești până la epuizare, să dai totul pentru cei din jur și să
                te întrebi:{' '}
                <span className="font-serif italic text-xl text-forest" data-id="element-633">
                  „Și eu acum ce fac?”
                </span>
              </p>

              <p data-id="element-634">
                Am trecut prin asta. Am lucrat 16 ani în contabilitate și taxe,
                am divorțat, am reconstruit totul de la zero. Și pe parcurs am
                descoperit că răspunsurile nu vin din a face mai mult, ci din a
                înțelege din ce loc trăiești și ce te ține acolo.
              </p>

              <p className="font-medium text-forest border-l-2 border-gold pl-4 mt-8 py-1" data-id="element-635">
                Aici intru eu: cu structură, cu blândețe și cu un proces care
                merge în profunzime, nu doar la suprafață.
              </p>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}